<script setup>

import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Button from "primevue/button";

const form = defineModel();
</script>

<template>

    <div class="w-full flex flex-col h-full">
        <p class="text-gray-600 dark:text-gray-200 m-5">{{ $t('settings.section_email_hint') }}</p>

        <div class="grid gap-4 m-5 mt-0">
            <div class="flex max-md:flex-col gap-4">

                <!-- Jméno -->
                <div class="flex flex-col items-start gap-1">
                    <label for="smtp_name" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_from_name') }}</label>
                    <InputText id="smtp_name"
                               v-model="form.smtp_name"
                               @change="form.validate('smtp_name')"
                               class="max-md:w-full"
                               :class="{'p-invalid': form.invalid('smtp_name')}"
                    >
                    </InputText>
                    <small v-if="form.invalid('smtp_name')" class="p-error">
                        {{ form.errors['smtp_name'] }}
                    </small>
                </div>

                <!-- Emailová adresa -->
                <div class="flex flex-col items-start gap-1">
                    <label for="smtp_address" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_address') }}</label>
                    <InputText id="smtp_address"
                               v-model="form.smtp_address"
                               class="max-md:w-full"
                               @change="form.validate('smtp_address')"
                               :class="{'p-invalid': form.invalid('smtp_address')}">
                    </InputText>
                    <small v-if="form.invalid('smtp_address')" class="p-error">
                        {{ form.errors['smtp_address'] }}
                    </small>
                </div>
            </div>

            <!-- Oddělovač -->
            <div class="border-t dark:border-neutral-700"></div>

            <!-- SMTP server a port -->
            <div class="grid max-md:grid-cols-1 grid-cols-5 md:gap-4">
                <div class="col-span-3 flex flex-col gap-1">
                    <label for="smtp_server" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_server') }}</label>
                    <InputText id="smtp_server"
                               v-model="form.smtp_server"
                               @change="form.validate('smtp_server')"
                               :class="{'p-invalid': form.invalid('smtp_server')}">
                    </InputText>
                    <small v-if="form.invalid('smtp_server')" class="p-error">
                        {{ form.errors['smtp_server'] }}
                    </small>
                </div>
                <div class="flex flex-col col-span-1 items-start gap-1 max-md:pt-4">
                    <label for="smtp_port" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_port') }}</label>
                    <InputText id="smtp_port"
                               v-model="form.smtp_port"
                               @change="form.validate('smtp_port')"
                               :class="{'p-invalid': form.invalid('smtp_port')}"

                               class="max-md:w-full"
                               keyfilter="int">
                    </InputText>
                    <small v-if="form.invalid('smtp_port')" class="p-error">
                        {{ form.errors['smtp_port'] }}
                    </small>
                </div>
            </div>

            <div class="flex max-md:flex-col gap-4">
                <!-- Uživatelské jméno -->
                <div class="flex flex-col items-start gap-1">
                    <label for="smtp_username" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_username') }}</label>
                    <InputText id="smtp_username"
                               v-model="form.smtp_username"
                               class="max-md:w-full"
                               fluid
                               @change="form.validate('smtp_username')"
                               :class="{'p-invalid': form.invalid('smtp_username')}">
                    </InputText>
                    <small v-if="form.invalid('smtp_username')" class="p-error">
                        {{ form.errors['smtp_username'] }}
                    </small>
                </div>

                <!-- Heslo -->
                <div class="flex flex-col items-start gap-1">
                    <label for="smtp_password" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('settings.email_password') }}</label>
                    <Password id="smtp_password"
                              v-model="form.smtp_password"
                              @change="form.validate('smtp_password')"
                              :class="{'p-invalid': form.invalid('smtp_password')}"
                              :placeholder="$t('settings.email_password_placeholder')"
                              class="max-md:w-full"
                              fluid
                              toggleMask>
                    </Password>
                    <small v-if="form.invalid('smtp_password')" class="p-error">
                        {{ form.errors['smtp_password'] }}
                    </small>
                </div>

            </div>
            <!-- Uložit tlačítko -->
        </div>
        <div class="grow"></div>
        <div class="p-4 border-t flex justify-end bg-neutral-50 dark:border-neutral-700 dark:bg-neutral-900">

            <Button :label="$t('common.save')"
                    :loading="form.processing"
                    @click="form.touch(['smtp_name', 'smtp_address', 'smtp_server', 'smtp_port', 'smtp_username', 'smtp_password']).submit()">
            </Button>
        </div>
    </div>

</template>

<style scoped lang="scss">

</style>
